export function filterScroll() {


    $(window).on("load", function () {
        let filtersPosition = $("#tags").offset().top;
        let url = window.location.href;
        let split1 = url.split("/");
        let split2 = url.split("#");

        let variant1 = split1.indexOf("tag");
        let variant2 = split1.indexOf("page");
        let variant3 = split2.indexOf("tags");


        if (variant1 !== -1 || variant2 !== -1 || variant3 !== -1) {
            setTimeout(function () {
                $("body, html").animate({scrollTop: (filtersPosition - $(".header").height() - 10)}, 0);
            }, 0);
        }

    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/blog-scroll.js